<template>
  <div class="fab-container">
    <v-fab-transition v-if="inWizardView">
      <v-tooltip bottom>
        <v-btn slot="activator" fab color="primary" @click="$emit('leave')">
          <v-icon>close</v-icon>
        </v-btn>
        <span v-html="$t('message.common.back')"></span>
      </v-tooltip>
    </v-fab-transition>

    <template v-if="inEditView">
      <v-fab-transition v-if="canDelete">
        <v-tooltip bottom>
          <v-btn slot="activator" fab color="primary" @click="$emit('delete')">
            <v-icon>delete</v-icon>
          </v-btn>
          <span v-html="$t('message.common.delete')"></span>
        </v-tooltip>
      </v-fab-transition>
      <template v-if="isDirty || loading">
        <v-fab-transition v-if="!creatingNewSlide && !loading">
          <v-tooltip bottom>
            <v-btn slot="activator" fab color="primary" @click="$emit('undo')">
              <v-icon>undo</v-icon>
            </v-btn>
            <span v-html="$t('message.common.undo')"></span>
          </v-tooltip>
        </v-fab-transition>
        <v-fab-transition v-else>
          <v-tooltip bottom>
            <v-btn slot="activator" fab color="primary" @click="$emit('leave')">
              <v-icon>close</v-icon>
            </v-btn>
            <span v-html="$t('message.common.back')"></span>
          </v-tooltip>
        </v-fab-transition>
        <v-fab-transition>
          <V-tooltip bottom>
            <v-btn slot="activator" fab :color="validForm ? 'accent' : 'error'" :loading="loading"
                   @click="$emit('confirm')">
              <v-icon>check</v-icon>
            </v-btn>
            <span v-html="$t('message.common.accept')"></span>
          </v-tooltip>
        </v-fab-transition>
      </template>
      <template v-else>
        <v-fab-transition>
          <v-tooltip bottom>
            <v-btn slot="activator" fab color="primary" @click="$emit('leave')">
              <v-icon>close</v-icon>
            </v-btn>
            <span v-html="$t('message.common.back')"></span>
          </v-tooltip>
        </v-fab-transition>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: 'nx-scrollytelling-slide-editor-buttons',
  props: {
    creatingNewSlide: Boolean,
    inEditView: Boolean,
    inWizardView: Boolean,
    isDirty: Boolean,
    validForm: Boolean,
    loading: Boolean,
    slideIndex: Number,
  },
  computed: {
    canDelete() {
      if (this.creatingNewSlide || this.loading) {
        return false;
      }
      return this.slideIndex !== 0;
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '../../../assets/stylus/variables.styl'

.fab-container {
  position: absolute;
  bottom: -32px;
  right: 0;
  padding-right: 18px;
}
</style>
